export default __webpack_public_path__ + "static/2385-d4af7ee14ee3d8f36d98cf23a3248807.gif";